import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { FloatPopupService } from 'app/services/float-popup.service';
import { WizardStepItem } from '../edit-wizard/wizard-step-title/wizard-step-title.component';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { Subscription } from 'rxjs';
import { LRSMap } from 'assets/TS/LRSMap_New';
import { MainDataMapLayersService } from 'app/services/main-data-map-layers.service';
import { fadeInOut } from 'assets/TS/SharedAnimations';
import { MainDataService } from 'app/services/main-data.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { DrawEvent } from 'ol/interaction/Draw';
import WKT from 'ol/format/WKT';
import GeoJSON from 'ol/format/GeoJSON';
import { LayerService } from 'app/services/layer.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import { TopoService } from 'app/services/topo.service';
import { Polygon } from 'ol/geom';
import { ToastrService } from 'ngx-toastr';
import { JstsService } from 'app/services/jsts.service';
import { EditFeatureService } from 'app/services/edit-feature.service';

interface GeomEditStepItem extends WizardStepItem {
	prop: StepType;
}
type StepType = 'selectAction' | 'drawNew' | 'isCarveout' | 'editBdry' | ''; // | 'selectAreaType' | 'drawNeighbor' | 'drawDonut'
type ActionType = 'edit' | 'delete' | 'add';
type AreaType = 'regular' | 'carvein' | 'carveout';

@Component({
  selector: 'app-boundary-geom-edit-wizard',
  templateUrl: './boundary-geom-edit-wizard.component.html',
  styleUrls: ['../line-geom-edit-wizard/line-geom-edit-wizard.component.css', './boundary-geom-edit-wizard.component.css'],
  animations: [fadeInOut]
})
export class BoundaryGeomEditWizardComponent implements OnInit, AfterViewInit, OnDestroy {

	currentAction: ActionType;
	actionList: {
		prop: ActionType;
		label: string;
	}[] = [{
			label: 'Modify',
			prop: 'edit'
		}, {
			label: 'Add',
			prop: 'add'
		}, {
			label: 'Delete',
			prop: 'delete'
	}];

	// currentAreaType: AreaType;
	// areaTypeList: {
	// 	type: AreaType;
	// 	label: string;
	// }[] = [
	// 	{
	// 		type: 'regular',
	// 		label: 'Regular'
	// 	}, {
	// 		type: 'carveout',
	// 		label: 'Carve-out Polygon'
	// 	}, {
	// 		type: 'carvein',
	// 		label: 'Carve-in Polygon'
	// 	}
	// ];

	isCarveout: boolean;
	isTopoLayerEdit: boolean;
	isDraw: boolean;

	currentStep: GeomEditStepItem;
	steps: GeomEditStepItem[] = [];

	private deletedPolygonsById: {
		[id: string]: {
			feat?;
			attrs?;
		}
	} = {};
	private step1: GeomEditStepItem = {
		num: 1,
		label: 'Select an edit mode',
		prop: 'selectAction',
		isFirst: true,
	};
	// private step2Add: GeomEditStepItem = {
	// 	num: 2,
	// 	label: 'New polygon type',
	// 	prop: 'selectAreaType'
	// };
	private stepsEdit: GeomEditStepItem[] = [{
		num: 2,
		label: 'Carve out from existing boundaries?',
		prop: 'isCarveout'
	}, {
		num: 3,
		label: '', // Select a boundary to edit, double click to end
		prop: 'editBdry'
	}];
	private stepsAdd: GeomEditStepItem[] = [{
		num: 2,
		label: 'Draw a new polygon',
		prop: 'drawNew'
	}];
		// private standaloneAddSteps: GeomEditStepItem[] = [
		// 	{
		// 		num: 3,
		// 		label: 'Draw a stand alone area, double click to end',
		// 		prop: 'drawStandalone',
		// 		isLast: true
		// 	}
		// ];
	// private neighborAddSteps: GeomEditStepItem[] = [
	// 	{
	// 		num: 3,
	// 		label: 'Draw area and existing boarder',
	// 		prop: 'drawNeighbor'
	// 	}, {
	// 		num: 4,
	// 		label: '',
	// 		prop: '',
	// 		isLast: true
	// 	}
	// ];
	// private donutAddSteps: GeomEditStepItem[] = [
	// 	{
	// 		num: 3,
	// 		label: 'Draw an area inside existing area',
	// 		prop: 'drawDonut',
	// 		isLast: true
	// 	}, {
	// 		num: 4,
	// 		label: '',
	// 		prop: '',
	// 		isLast: true
	// 	}
	// ];

	private hasModifiedData: boolean;

	private map: LRSMap.Map;

	private polygonEditSub: Subscription;
	private editListHoldSub: Subscription;
	private mapSub: Subscription;
	constructor(
		private toastr: ToastrService,
		private activityService: ActivityService,
		private attrIndexService: AttrIndexService,
		private commonService: CommonFunctionService,
		private editFeatureService: EditFeatureService,
		private floatPopupService: FloatPopupService,
		private jstsService: JstsService,
		private layerService: LayerService,
		private mainDataService: MainDataService,
		private mapService: MainDataMapService,
		private mapLayerService: MainDataMapLayersService,
		private topoService: TopoService
	) { }

	close () {
		this.cancel();
	}
	cancel() {
		this.editFeatureService.bdryWizardBS.next({
			isOn: false
		});
		if (this.hasModifiedData) {
			this.activityService.refreshData.next();
		}
		this.removeAll();
		this.floatPopupService.closePopup(BoundaryGeomEditWizardComponent);
	}
	addCards() {
		switch (this.currentAction) {
			case 'delete':
				Object.keys(this.deletedPolygonsById).forEach((id) => {
					let attrs = this.mainDataService.getDataAttrs(id);
					if (!attrs) {
						console.log('need debug: cannot find attrs.');
						return;
					}
					this.mainDataService.setDataAttrs(id, this.attrIndexService.isDeletedKey, true);
					this.mainDataService.addRecToCard(id);
				});
				break;
			case 'edit':
			case 'add':
				if (this.currentAction === 'add') {
							// if (this.currentAreaType === 'standalone') {
							// 	this.mapService.removeDataModify();
							// 	this.mapService.moveFeaturesBackFromModifyLayer();
							// } else
					// if (this.currentAreaType === 'regular') {
					// 	this.mapService.moveFeaturesBackFromModifyLayer(null, null, this.map.addedLayers[this.mapLayerService.topojsonLayerName]);
					// } else { // Carve
					// 	this.mapService.removeDataModify();
					// 	this.mapService.moveFeaturesBackFromModifyLayer();
					// }
					this.mapService.moveFeaturesBackFromModifyLayer(null, null, this.map.addedLayers[this.mapLayerService.topojsonLayerName]);
				}

				const editHoldIds = this.activityService.editRecordHoldListBS.getValue().ids;
				const editedIds = this.activityService.editRecordListBS.getValue().ids;
				editHoldIds.forEach(recId => {
					if (editedIds.indexOf(recId) === -1) {
						editedIds.push(recId);
					}
				});
				this.activityService.editRecordListBS.next({
					ids: editedIds,
					source: 'main'
				});
				break;
		}

		this.removeAll();
		this.activityService.changeTabSubject.next({
			tabKey: 'data'
		});
		this.editFeatureService.bdryWizardBS.next({
			isOn: false
		});
		this.floatPopupService.closePopup(BoundaryGeomEditWizardComponent);
	}
	checkAddCardsDisabled(stepType: StepType) {
		if (this.isTopoLayerEdit || this.isDraw) {
			return true;
		}
		switch (this.currentAction) {
			case 'add':
				return !this.hasModifiedData;
			case 'edit':
				return stepType !== 'editBdry' || !this.hasModifiedData;
			case 'delete':
				return !Object.keys(this.deletedPolygonsById).length;
			default:
				return true;
		}
	}

	onSelectAction() {
		this.stopDraw();
		this.stopEdit();

		this.steps = [this.step1];
		let nextStep: GeomEditStepItem;
		switch (this.currentAction) {
			case 'edit':
				this.steps = this.steps.concat(this.stepsEdit);
				nextStep = this.stepsEdit[0];
				break;
			case 'add':
				this.steps = this.steps.concat(this.stepsAdd);
				nextStep = this.stepsAdd[0];
				this.startAddNew();
				// this.steps.push(this.step2Add);
				// nextStep = this.step2Add
				break;
			case 'delete':
				this.startPickPolygonsDelete();
				break;
		}
		if (nextStep && this.currentStep.num >= nextStep.num) {
			// TODO: remove pick up, etc



		}
		this.changeCurrentStep(nextStep);
	}
	// onSelectAreaType() {
	// 	this.stopDraw();
	// 	this.stopEdit();

	// 	let step: GeomEditStepItem;
	// 	const currentSteps = [this.step1, this.step2Add];
	// 	switch (this.currentAreaType) {
	// 		// case 'standalone':
	// 		case 'carvein':
	// 		case 'carveout':
	// 			if (this.currentAction === 'add') {
	// 				this.steps = currentSteps.concat(this.donutAddSteps);
	// 				step = this.steps.find(s => s.prop === 'drawDonut');
	// 				// this.startAdd(true);
	// 			}
	// 			break;
	// 		case 'regular':
	// 			if (this.currentAction === 'add') {
	// 				this.steps = currentSteps.concat(this.neighborAddSteps);
	// 				step = this.steps.find(s => s.prop === 'drawNeighbor');
	// 				this.startAdd();
	// 			}
	// 			break;
	// 		// case 'donut':
	// 		// 	if (this.currentAction === 'add') {
	// 		// 		this.steps = currentSteps.concat(this.donutAddSteps);
	// 		// 		step = this.steps.find(s => s.prop === 'drawDonut');
	// 		// 	}
	// 		// 	break;
	// 	}
	// 	this.changeCurrentStep(step);
	// }

	onToggleCarveout() {
		if (this.currentStep.prop === 'editBdry') {
			this.stopEdit();
			this.restore(); // Need to stop edit before restore since the edited data need to be brought back to data layer
		}
		const step = this.stepsEdit.find(s => s.prop === 'editBdry');
		this.changeCurrentStep(step);
		if (this.isCarveout) {
			step.label = 'Draw carve-out polygon';
			this.startAddCarveout();
		} else {
			step.label = 'Edit existing polygons';
			this.startTopoLayerEdit();
		}
	}

	private removeAll() {
		// this.stopPick();
		this.activityService.editRecordHoldListBS.next({
			ids: []
		});
		this.stopEdit();
		this.stopDraw();
		//
		this.mapService.removeDataModify();
		this.map.addedLayers[this.mapLayerService.dataModifyLayerName].getSource().clear();
		// Set modify layer visible
		if (!this.map.addedLayers[this.mapLayerService.dataModifyLayerName].getVisible()) {
			this.map.addedLayers[this.mapLayerService.dataModifyLayerName].setVisible(true);
		}
		this.mapService.removeMapDblclickStop(this.map);
		if (this.map.addedLayers[this.mapLayerService.highlightLayerName]) {
			this.map.removeLayer(this.mapLayerService.highlightLayerName);
		}
		this.updateEditContextmenu(false);
	}

	private changeCurrentStep(step: GeomEditStepItem) {		
		if (!step) {
			return;
		}
		switch (step.prop) {
			case 'selectAction':
				break;
		}
		this.currentStep = step;
	}

	private startAddCarveout() {
		const editLayer = this.map.addedLayers[this.mapLayerService.dataModifyLayerName];
		this.startDraw(editLayer);
		this.mapService.drawInteraction.on('drawend', (e: DrawEvent) => {
			this.stopDraw();

			this.mapService.removeDblClickZoomInteraction(this.map);
			// const carveFeat = e.feature;

			// Modify
			this.mapService.addDataModify(() => {}, () => {

			});
			this.addCarveoutDblClickStop();
		});
	}
	private addCarveoutDblClickStop() {
		setTimeout(() => {
			const jstsParser = this.jstsService.getJstsParser();
			this.mapService.addMapDblclickStop(this.map, () => {
				const carveFeat = this.map.addedLayers[this.mapLayerService.dataModifyLayerName].getSource().getFeatures()[0];
				const carveFeatGeomJsts = jstsParser.read(carveFeat.getGeometry());
				//
				this.map.addedLayers[this.mapLayerService.dataLayerName].getSource().getFeatures().forEach(f => {
					const originalAttr = this.mainDataService.getDataOriginAttrs(f.getId());
					if (!originalAttr || !originalAttr[this.attrIndexService.geomColManual]) {
						return;
					}
					const wktFormat = new WKT();
					const olGeom = wktFormat.readFeature(originalAttr[this.attrIndexService.geomColManual]).getGeometry();
					const geomJsts = jstsParser.read(olGeom);
					const intersection = this.jstsService.getJstsOverlayOp().intersection(geomJsts, carveFeatGeomJsts);
					// Check intersects
					if (intersection.getCoordinates().length) {
						let olGeomAfterIntersection;
						// Get remaining geom after intersects
						const difference = this.jstsService.getJstsOverlayOp().difference(geomJsts, carveFeatGeomJsts);
						if (difference.getCoordinates().length) {
							olGeomAfterIntersection = jstsParser.write(difference);
						}
						// Update geom
						if (olGeomAfterIntersection) {
							f.setGeometry(olGeomAfterIntersection);
						} else { // The whole feature is carved out
							// this.toastr.info('Can not carve out a whole boundry');
							// return;
							f.setGeometry();
							this.mainDataService.setDataAttrs(f.getId(), this.attrIndexService.isDeletedKey, true);
						}
						this.manualAddPolygonToCard(f.getId());
					}
				});
				this.map.addedLayers[this.mapLayerService.dataModifyLayerName].setVisible(false);
				this.updateEditContextmenu(true, 'Edit carve-out');
			});
		});
	}
	private startAddNew() {
		this.startTopoLayerEdit(true);

		const editLayer = this.map.addedLayers[this.mapLayerService.topojsonLayerName];
		this.startDraw(editLayer);

		this.mapService.drawInteraction.on('drawend', (e: DrawEvent) => {
			this.stopDraw();

			this.mapService.removeDblClickZoomInteraction(this.map);

			const feat = e.feature;
			const uuidCol = this.activityService.selectedLayerBS.getValue().layer.category.colPrefix + '_' + this.attrIndexService.globalIdColLower;
			const rec = this.mainDataService.addNewCard(uuidCol, 'control', true);
			const recId = rec[uuidCol];
			// set geom
			const wktFormat = new WKT();
			const wktStr = wktFormat.writeGeometry(feat.getGeometry());
			rec[this.attrIndexService.geomColManual] = wktStr;
			this.mainDataService.addDataToStoredRecords([rec], uuidCol, 'replace');
			// this.mainDataService.setDataAttrs(recId, this.attrIndexService.geomColManual, wktStr);
			// this.mainDataService.setDataAttrs(recId, this.attrIndexService.isNewDataKey, true);
			feat.setId(recId);

			// Add Modify
			this.mapService.addDataModify(() => {}, () => {

			});
			
			this.addNewDblclickStop();
		});
	}
	// Add doubleclick stop for adding new polygon
	private addNewDblclickStop() {
		setTimeout(() => {
			const jstsParser = this.jstsService.getJstsParser();
			const wktFormat = new WKT();
			const layer = this.map.addedLayers[this.mapLayerService.topojsonLayerName];
			this.mapService.addMapDblclickStop(this.map, () => {
				const addedFeat = layer.getSource().getFeatures().find(f => {
					const attrs = this.mainDataService.getDataAttrs(f.getId());
					return attrs && attrs[this.attrIndexService.isNewDataKey];
				})
				const addedFeatGeomJsts = jstsParser.read(addedFeat.getGeometry());
				layer.getSource().getFeatures().forEach(f => {
					if (f === addedFeat) {
						return;
					}
					const originalAttr = this.mainDataService.getDataOriginAttrs(f.getId());
					if (!originalAttr || !originalAttr[this.attrIndexService.geomColManual]) {
						return;
					}
					const olGeom = wktFormat.readFeature(originalAttr[this.attrIndexService.geomColManual]).getGeometry();
					const geomJsts = jstsParser.read(olGeom);
					const intersection = this.jstsService.getJstsOverlayOp().intersection(geomJsts, addedFeatGeomJsts);
					// Check intersects
					if (intersection.getCoordinates().length) {
						let olGeomAfterIntersection;
						// Get remaining geom after intersects
						const difference = this.jstsService.getJstsOverlayOp().difference(geomJsts, addedFeatGeomJsts);
						if (difference.getCoordinates().length) {
							olGeomAfterIntersection = jstsParser.write(difference);
						}
						// Update geom
						if (olGeomAfterIntersection) {
							f.setGeometry(olGeomAfterIntersection);
						} else { // The whole feature is carved out
							// this.toastr.info('Can not carve out a whole boundry');
							// return;
							f.setGeometry();
							this.mainDataService.setDataAttrs(f.getId(), this.attrIndexService.isDeletedKey, true);
						}
						this.manualAddPolygonToCard(f.getId(), true);
					}
				});
				this.manualAddPolygonToCard(addedFeat.getId(), true);

				this.stopEdit();
				this.updateEditContextmenu(true, 'Edit vertex');
			});
		});
	}
	private turnOnEditForAdd() {
		const dataLayer = this.map.addedLayers[this.mapLayerService.dataLayerName];
		// Re update topo
		const geojsonFormat = new GeoJSON();
		const geojsonData = JSON.parse(geojsonFormat.writeFeatures(dataLayer.getSource().getFeatures()))
		const topoFeats =  this.topoService.convertGeojsonToTopoFeatures(geojsonData);
		this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName].getSource().clear();
		this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName].getSource().addFeatures(topoFeats);
		//
		this.mapService.mapEditing.next({
			isOn: true,
			source: 'control',
			skipGetTopo: true
		});
		this.isTopoLayerEdit = true;

		this.addNewDblclickStop();
	}
	
	private startTopoLayerEdit(skipDblClickStop?: boolean, id?) {
		if (!this.mapService.mapEditing.getValue().isOn) {
			if (!skipDblClickStop) {
				this.mapService.addMapDblclickStop(this.map, () => {
					this.stopEdit();
				});	
			}
			this.mapService.mapEditing.next({
				isOn: true,
				source: 'control',
				selectedId: id
			});
			this.isTopoLayerEdit = true;
		}
	}
	private stopEdit() {
		if (this.mapService.mapEditing.getValue().isOn) {
			this.mapService.removeMapDblclickStop(this.map);
			this.mapService.mapEditing.next({
				isOn: false,
				source: 'control'
			});
			this.isTopoLayerEdit = false;
		}
	}
	private startDraw(editLayer) {
		this.isDraw = true;
		this.mapService.addDrawInteraction(this.map, 'Polygon', editLayer);
	}
	private stopDraw() {
		this.isDraw = false;
		this.mapService.removeDrawInteraction(this.map);
	}
	private startPickPolygonsDelete() {
		const layers = [this.mapLayerService.dataLayerName];
		this.mapService.startPickOnMap(this.map, layers, async (result) => {
			const polygon = result.feat;
			if (polygon) {
				const selectedLayer = this.map.addedLayers[this.mapLayerService.highlightLayerName];
				const featId = polygon.getId();
				let info = this.deletedPolygonsById[featId];
				if (info) {
					delete this.deletedPolygonsById[featId];
					selectedLayer.getSource().removeFeature(polygon);
				} else {
					info = {
						feat: polygon,
						attrs: this.mainDataService.getDataAttrs(featId)
					}
					this.deletedPolygonsById[featId] = info;
					selectedLayer.getSource().addFeature(polygon);
				}
			} else {
				this.toastr.info('Polygon not found.')
			}
		}, null, this.attrIndexService.cursorArrow);
		this.mapService.addMapDblclickStop(this.map, () => {
			this.mapService.endPickOnMap(this.map);
		});
	}
	private restore() {
		const dataLayer = this.map.addedLayers[this.mapLayerService.dataLayerName];
		const feats = dataLayer.getSource().getFeatures();
		feats.forEach(f => {
			const originAttrs = this.mainDataService.getDataOriginAttrs(f.getId());
			const attrs = this.mainDataService.getDataAttrs(f.getId());
			const originGeom = originAttrs ? originAttrs[this.attrIndexService.geomColManual] : null;
			const geom = attrs ? attrs[this.attrIndexService.geomColManual] : null;
			if (geom && originGeom && originGeom !== geom) {
				const wktFormat = new WKT();
				const originGeom = wktFormat.readFeature(originAttrs[this.attrIndexService.geomColManual]);
				f.setGeometry(originGeom);
			}
		});
		// Clear added carveout
		const modifyLayer = this.map.addedLayers[this.mapLayerService.dataModifyLayerName];
		modifyLayer.getSource().clear();
	}
	private updateEditContextmenu(isShow, text?: string) {
		this.editFeatureService.showPolygonEditBS.next({
			showEditContextmenu: isShow,
			menuText: text
		});
	}
	private manualAddPolygonToCard(id, syncUpdateFromTopo?: boolean) {
		const dataLayer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
		let feat = dataLayer.getSource().getFeatureById(id);
		if (!syncUpdateFromTopo) {
			if (!feat) {
				return;
			}
		} else {
			// Find feat on dataLayer
			let featOnTopoLayer = this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName].getSource().getFeatureById(id);
			if (!featOnTopoLayer) {
				return;
			}
			if (!feat) {
				feat = featOnTopoLayer.clone();
				feat.setId(featOnTopoLayer.getId());
				dataLayer.getSource().addFeature(feat);
			} else {
				feat.setGeometry(featOnTopoLayer.getGeometry());
			}
		}
		const attrs = this.mainDataService.getDataAttrs(id);
		if (!attrs[this.attrIndexService.isDeletedKey]) {
			const wktFormat = new WKT();
			// Update stored geom
			const wktString = wktFormat.writeGeometry(feat.getGeometry());
			// propsOnData[this.attrKey][this.geomColName_manual] = wktString;
			// Add card
			if (!attrs[this.attrIndexService.isEditedKey]) {
				// Add card
				this.mainDataService.addRecToCard(id, this.activityService.selectedLayerBS.getValue().layer.category.code, null, null, true);				
			}
			// card[this.geomColName_manual] = wktString;
			this.mainDataService.setDataAttrs(id, this.attrIndexService.geomColManual, wktString);
		}
	}

	// private async getTopojson (mapExtent: number[], skipUpdateMap?: boolean) {
	// 	const layerId = this.activityService.selectedLayerBS.getValue().layer.id;
	// 	let data;
	// 	const randomId = this.commonService.getRandomId();
	// 	this.commonService.setLoadingSpinner(true, randomId);
	// 	try {
	// 		data = await this.layerService.getLayerGeomBoundingBox(layerId, mapExtent, true);		
	// 	} catch (err) {
	// 		console.log(err);
	// 	}
	// 	this.commonService.setLoadingSpinner(false, randomId);
	// 	// const topologizedGeojson = {
	// 	// 	type: 'FeatureCollection',
	// 	// 	features: topologizedAreas.topologized ? topologizedAreas.topologized.map(d => {
	// 	// 		return {
	// 	// 			geometry: {
	// 	// 				type: d.geom.type,
	// 	// 				coordinates: d.geom.coordinates
	// 	// 			},
	// 	// 			id: d.gid,
	// 	// 			source: d.source
	// 	// 		};
	// 	// 	}): []
	// 	// };
	// 	// const features = this.convertGeojsonToTopoFeatures(topologizedGeojson);


	// 	if (!skipUpdateMap) {
	// 		const features =  this.topoService.convertGeojsonToTopoFeatures(data);
	// 		this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName].getSource().clear();
	// 		this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName].getSource().addFeatures(features);
	// 		return {
	// 			geojson: data,
	// 			features: features
	// 		};
	// 	} else {
	// 		return {
	// 			geojson: data
	// 		}
	// 	}
	// }
	ngOnInit() {
		this.editFeatureService.bdryWizardBS.next({
			isOn: true
		});
		this.activityService.removeCurrentSelection();

		this.steps = [this.step1];
		this.changeCurrentStep(this.steps[0]);
	}
	ngAfterViewInit(): void {
		this.mapSub = this.mapService.mapBS.subscribe(data => {
			this.map = data;
			if (!this.map.addedLayers[this.mapLayerService.highlightLayerName]) {
				this.mapLayerService.addHighlightLayer(this.map);
			}
		});
		this.editListHoldSub = this.activityService.editRecordHoldListBS.subscribe(data => {
			if (data.ids && data.ids.length) {
				this.hasModifiedData = true;
			} else {
				this.hasModifiedData = false;
			}
		});
		this.polygonEditSub = this.editFeatureService.polygonEditSubject.subscribe(data => {
			if (data && data.activate) {
				switch (this.currentStep.prop) {
					case 'drawNew':
						this.turnOnEditForAdd();
						break;
					case 'editBdry':
						if (this.isCarveout) {
							this.map.addedLayers[this.mapLayerService.dataModifyLayerName].setVisible(true);
							this.mapService.addDataModify(() => {}, () => {});
							this.addCarveoutDblClickStop();
						} else {

						}
						break;
				}
			}
		})
	}
	ngOnDestroy(): void {
		this.mapSub.unsubscribe();
		this.editListHoldSub.unsubscribe();
		this.polygonEditSub.unsubscribe();
	}
}
